const useLanguage = () => {
  const getValue = (field: string, object: any): string => {
    return object[field] as string;
  };
  return { getValue };
};

export default useLanguage;
